import { LEGACY_REDIRECT_MAP } from '../constants/legacyRedirectMap';
import { userLocale } from './userLocale';

/**
 * Resolves the language segment for the new URL based on the user's locale.
 * @param {string} detectedLocale - e.g. "es-ES", "en-GB", "nl-NL"
 * @param {object} storeRedirectInfo - entry from LEGACY_REDIRECT_MAP
 * @returns {string} language segment for the URL (e.g. "es", "en")
 */
const resolveLanguage = (detectedLocale, storeRedirectInfo) => {
  const langPrefix = detectedLocale.split('-')[0].toLowerCase();
  return storeRedirectInfo.langMap[langPrefix] || storeRedirectInfo.defaultLang;
};

/**
 * Builds the full new URL for a legacy store redirect.
 * @param {string} storeId - e.g. "14766"
 * @returns {string|null} full redirect URL, or null if store not in map
 */
export const buildRedirectUrl = (storeId) => {
  const storeInfo = LEGACY_REDIRECT_MAP[storeId];
  if (!storeInfo) return null;

  const detectedLocale = userLocale();
  const lang = resolveLanguage(detectedLocale, storeInfo);

  return `/${storeInfo.country}/${lang}/stores-locator/${storeInfo.slug}`;
};
